import { StateCreator } from 'zustand';

export interface ProfileTabSlice {
    activeTab: string;
    setActiveTab: (tabId: string) => void;
    clearActiveTab: () => void;
}

export const createProfileTabSlice: StateCreator<ProfileTabSlice> = (set, get) => ({
    activeTab: '1', // Default tab
    setActiveTab: (tabId: string) => {
        set({ activeTab: tabId });
    },
    clearActiveTab: () => {
        set({ activeTab: 'profile' }); // Reset to default tab
    }
});
